import { Tooltip } from "antd";
import "./robot-status-signal.css";
import { Fragment, useState } from "react";

const RoboStatusSignal = ({ StatusSignal, NoBorder, NoBackground }) => {
  const statusSignal = StatusSignal ? StatusSignal : "";
  const redLightSet = new Set(["error", "disconnected", "estop", "charging"]);
  const greenLightSet = new Set([
    "autonomous",
    "sharedauto",
    "estop",
    "charging",
  ]);
  const blueLightSet = new Set([
    "teleoperation",
    "sharedauto",
    "disconnected",
    "charging",
  ]);

  return (
    <Fragment>
      <Tooltip title={statusSignal}>
        <div
          className={`traffic-light ${NoBackground ? "no-bg" : ""} ${
            NoBorder ? "no-border" : ""
          }`}
        >
          <div
            className={`light red ${
              redLightSet.has(statusSignal.toLowerCase()) ? "on" : ""
            }`}
          />
          <div
            className={`light green ${
              greenLightSet.has(statusSignal.toLowerCase()) ? "on" : ""
            }`}
          />
          <div
            className={`light blue ${
              blueLightSet.has(statusSignal.toLowerCase()) ? "on" : ""
            }`}
          />
        </div>
      </Tooltip>
    </Fragment>
  );
};

export default RoboStatusSignal;
